import React, { useState, useEffect } from 'react';
import moment from "moment";
import CircularProgress from '@mui/material/CircularProgress';
import { Grid, Table, TableBody, TableContainer, TableCell, TableHead, TableRow, Paper, Menu, MenuItem, Button, Box, Typography } from "@material-ui/core";
import BoxWrapper from './boxWrapper';
import Tooltip from '@mui/material/Tooltip';
import { Snackbar, Alert } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import axios from "../../axios-order";
import { FormControl, InputLabel, Select } from '@mui/material';
import { IconButton } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Date from './Date'
import { ValidatorForm } from "react-material-ui-form-validator";
import DownloadIcon from '@mui/icons-material/Download';
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import RefreshIcon from '@mui/icons-material/Refresh';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BusinessIcon from '@mui/icons-material/Business';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import {
  DataGridPro,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector
} from '@mui/x-data-grid-pro';
function Summary() {
  const [fromDateMonthYearDisplay, setFromDateMonthYearDisplay] = useState(null);
  const [toDateMonthYearDisplay, setToDateMonthYearDisplay] = useState(null);
  const [taskIds, setTaskIds] = useState([]);
  const [records, setRecords] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [invoiceIdToCancel, setInvoiceIdToCancel] = useState(null);
  const [reason, setReason] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('STATUS');
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const openStatus = Boolean(statusAnchorEl);
  const [einvoiceData, setEinvoiceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([])
  const [anotherloading, setAnotherLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [selectedDocumentType, setSelectedDocumentType] = useState('DOCUMENT TYPE');
  const [documentTypeAnchorEl, setDocumentTypeAnchorEl] = useState(null);
  const openDocumentType = Boolean(documentTypeAnchorEl);

  const [selectedCategory, setSelectedCategory] = useState('CATEGORY');
  const [categoryAnchorEl, setCategoryAnchorEl] = useState(null);
  const openCategory = Boolean(categoryAnchorEl);
  const [form16DataLoading, setForm16DataLoading] = useState(false)
  const [supplierData, setSupplierData] = useState([])
  const [isLoading, setIsLoading] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);


  const [selectedRcm, setSelectedRcm] = useState('RCM');
  const [rcmAnchorEl, setRcmAnchorEl] = useState(null);
  const openRcm = Boolean(rcmAnchorEl);
  const [selectedRecords, setSelectedRecords] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [loadingIds, setLoadingIds] = useState([]);
  const [formValues, setFormValues] = useState({
    invoiceType: 'Tax Invoice',
  });
  const [logData, setLogData] = useState([]);
  const [errorLog, setErrorLog] = useState([]);
  const [openEwayCancelDialog, setOpenEwayCancelDialog] = useState(false);
  const [ewayCancelData, setEwayCancelData] = useState({
    ewbNo: '',
    cancelRsnCode: '',
    cancelRmrk: ''
  });
  const [openEwayExtendDialog, setOpenEwayExtendDialog] = useState(false);
  const [ewayExtendData, setEwayExtendData] = useState({
    ewbNo: '',
    vehicleNo: '',
    fromPlace: '',
    fromPincode: '',
    fromState: '',
    remainingDistance: '',
    transDocNo: '',
    transDocDate: '',
    transMode: '5',
    extnRsnCode: '',
    extnRemarks: '',
    consignmentStatus: 'T',
    transitType: 'R',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
  });



  const handleAddButtonClick = async () => {
    if (selectedRecords.length === 0) {

      return;
    }



    const business_entity_id = localStorage.getItem('business_entity_id');
    const user_id = localStorage.getItem('user_id');
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    const gstin = localStorage.getItem('gstin');
    const status = "Generated"
    const irp_number = "vay"

    try {
      setLoading(true);
      const response = await axios.post('/einvoice/post_gov_portal_details', {
        id: selectedRecords,
        business_entity_id,
        gstin,
        user_id,
        status
      });

      console.log('Bulk Generate Response:', response.data);

      const message = response.data.message || 'Operation completed';
      let displayMessage = message;

      // Check for validation errors
      if (response.data.errors && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
        const errorDetails = response.data.errors.join('\n• ');
        displayMessage = `${message}\n\nValidation Errors:\n• ${errorDetails}`;
      }

      setSnackbarMessage(displayMessage);

      if (response.data.success === true ||
        response.data.status === true ||
        message.toLowerCase().includes('successfully') ||
        message.toLowerCase().includes('success')) {
        setSnackbarSeverity('success');
      } else {
        setSnackbarSeverity('error');
      }
      setSnackbarOpen(true);
      onSubmitHandler();
    } catch (error) {
      console.error("Error submitting records:", error);

      let errorMessage = 'Error occurred while generating E-Invoice.';

      if (error.response && error.response.data) {
        const errorData = error.response.data;
        errorMessage = errorData.message || errorMessage;

        if (errorData.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
          const errorDetails = errorData.errors.join('\n• ');
          errorMessage = `${errorMessage}\n\nValidation Errors:\n• ${errorDetails}`;
        }
      }

      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRecords(records.map(record => record.id));
    } else {
      setSelectedRecords([]);
    }
  };

  const handleSelect = (id) => {
    setSelectedRecords(prevSelected =>
      prevSelected.includes(id)
        ? prevSelected.filter(recordId => recordId !== id)
        : [...prevSelected, id]
    );
  };

  const handleSecondButtonClick = () => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    const gstin = localStorage.getItem('gstin');
    const irp_number = 'vay';
    setAnotherLoading(true);
    axios
      .post('/einvoice/cancel_generated_einvoice', {
        id: selectedRecords,
        business_entity_id,
        username,
        password,
        gstin,
        irp_number,
        reason,
      })
      .then(response => {
        if (response.data && response.data.message) {
          const message = response.data.message;
          let displayMessage = message;

          if (response.data.errors && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
            const errorDetails = response.data.errors.join('\n• ');
            displayMessage = `${message}\n\nValidation Errors:\n• ${errorDetails}`;
          }

          setSnackbarMessage(displayMessage);

          if (response.data.success === true ||
            response.data.status === true ||
            message.toLowerCase().includes('successfully') ||
            message.toLowerCase().includes('success')) {
            setSnackbarSeverity('success');
          } else {
            setSnackbarSeverity('error');
          }

          setSnackbarOpen(true);
          onSubmitHandler();
        }
      })
      .catch(error => {
        console.error('Error canceling invoice:', error);

        let errorMessage = 'An unexpected error occurred.';

        if (error.response && error.response.data) {
          const errorData = error.response.data;
          errorMessage = errorData.message || errorMessage;

          if (errorData.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
            const errorDetails = errorData.errors.join('\n• ');
            errorMessage = `${errorMessage}\n\nValidation Errors:\n• ${errorDetails}`;
          }
        }

        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setAnotherLoading(false);
      });
  };

  const refreshTaskStatus = async (invoiceId, documentNumber, task_id) => {
    console.log('Refresh clicked - Invoice ID:', invoiceId, 'Task ID:', task_id, 'Document Number:', documentNumber);

    if (!task_id) {
      setSnackbarMessage('No task ID available for this invoice');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }

    const business_entity_id = localStorage.getItem('business_entity_id');

    setLoadingIds(prev => [...prev, invoiceId]);

    try {
      console.log('Calling refresh_task API with:', {
        business_entity_id,
        task_id: task_id,
        document_number: documentNumber,
        id: invoiceId
      });

      const response = await axios.post('/einvoice/refresh_task', {
        business_entity_id,
        task_id: task_id,
        document_number: documentNumber,
        id: invoiceId
      });

      console.log('Refresh API Response:', response.data);

      if (response.data) {
        const message = response.data.message || 'Task status refreshed';

        let displayMessage = message;
        if (response.data.errors && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
          const errorDetails = response.data.errors.join('\n• ');
          displayMessage = `${message}\n\nValidation Errors:\n• ${errorDetails}`;
        }

        if (message.toLowerCase().includes('processing') ||
          message.toLowerCase().includes('pending') ||
          message.toLowerCase().includes('in progress')) {
          setSnackbarMessage(displayMessage);
          setSnackbarSeverity('info');
          setSnackbarOpen(true);
        } else if (response.data.status ||
          response.data.success === true ||
          message.toLowerCase().includes('successfully') ||
          message.toLowerCase().includes('success')) {
          setSnackbarMessage(displayMessage);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
        } else {
          setSnackbarMessage(displayMessage);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }

        onSubmitHandler();
      }
    } catch (error) {
      console.error('Error refreshing task status:', error);

      let errorMessage = 'Error occurred while refreshing task status';

      if (error.response && error.response.data) {
        const errorData = error.response.data;
        errorMessage = errorData.message || errorMessage;

        if (errorData.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
          const errorDetails = errorData.errors.join('\n• ');
          errorMessage = `${errorMessage}\n\nValidation Errors:\n• ${errorDetails}`;
        }
      }

      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoadingIds(prev => prev.filter(item => item !== invoiceId));
    }
  };


  const openEwayCancelPopup = (row) => {
    setEwayCancelData({
      ewbNo: row.eway_bill_no || '',
      cancelRsnCode: '',
      cancelRmrk: ''
    });
    setOpenEwayCancelDialog(true);
  };

  const handleClearEwayCancel = () => {
    setEwayCancelData({
      ewbNo: '',
      cancelRsnCode: '',
      cancelRmrk: ''
    });
  };

  const submitEwayCancel = async () => {
    try {
      if (!ewayCancelData.cancelRsnCode) {
        setSnackbarMessage("Please select reason");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }

      const business_entity_id = localStorage.getItem('business_entity_id');

      const payload = {
        business_entity_id,
        ewbNo: Number(ewayCancelData.ewbNo),
        cancelRsnCode: ewayCancelData.cancelRsnCode,
        cancelRmrk: ewayCancelData.cancelRmrk || "Cancelled"
      };

      const res = await axios.post('/ewaybill/cancel_eway_bill', payload);

      setSnackbarMessage(res.data.message);
      setSnackbarSeverity(res.data.status ? "success" : "error");
      setSnackbarOpen(true);

      setOpenEwayCancelDialog(false);
      onSubmitHandler();

    } catch (err) {
      setSnackbarMessage("Cancel failed");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const openEwayExtendPopup = (row) => {
    setEwayExtendData({
      ewbNo: row.eway_bill_no || '',
      vehicleNo: '',
      fromPlace: '',
      fromPincode: '',
      fromState: '',
      remainingDistance: '',
      transDocNo: '',
      transDocDate: '',
      transMode: '5',
      extnRsnCode: '',
      extnRemarks: '',
      consignmentStatus: 'T',
      transitType: 'R',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
    });
    setOpenEwayExtendDialog(true);
  };

  const handleClearEwayExtend = () => {
    setEwayExtendData(prev => ({
      ...prev,
      vehicleNo: '',
      fromPlace: '',
      fromPincode: '',
      fromState: '',
      remainingDistance: '',
      transDocNo: '',
      transDocDate: '',
      transMode: '5',
      extnRsnCode: '',
      extnRemarks: '',
      consignmentStatus: 'T',
      transitType: 'R',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
    }));
  };

const submitEwayExtend = async () => {
  try {
    if (!ewayExtendData.extnRsnCode) {
      setSnackbarMessage("Please select reason for extension");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const business_entity_id = localStorage.getItem('business_entity_id');
    const consignmentStatusMap = {
      "T": "In Transit",
      "M": "In Movement",
    };

    const transitTypeMap = {
      "R": "Regular",
      "T": "ODC",
    };

    const transModeMap = {
      "1": "Road",
      "2": "Rail",
      "3": "Air",
      "4": "Ship",
    };

    const extnRsnCodeMap = {
      1: "Natural Calamity",
      2: "Law and Order Situation",
      3: "Transshipment",
      4: "Accident",
      5: "Others",
    };

    const payload = {
      business_entity_id: parseInt(business_entity_id),
      ewbNo: Number(ewayExtendData.ewbNo),
      vehicleNo: ewayExtendData.vehicleNo,
      fromPlace: ewayExtendData.fromPlace,
      fromPincode: Number(ewayExtendData.fromPincode),
      fromState: Number(ewayExtendData.fromState),
      remainingDistance: Number(ewayExtendData.remainingDistance),
      transDocNo: ewayExtendData.transDocNo,
      transDocDate: ewayExtendData.transDocDate
        ? moment(ewayExtendData.transDocDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '',
      transMode: transModeMap[ewayExtendData.transMode] ?? ewayExtendData.transMode,
      extnRsnCode: extnRsnCodeMap[Number(ewayExtendData.extnRsnCode)] ?? ewayExtendData.extnRsnCode,
      consignmentStatus: consignmentStatusMap[ewayExtendData.consignmentStatus] ?? ewayExtendData.consignmentStatus,
      transitType: transitTypeMap[ewayExtendData.transitType] ?? ewayExtendData.transitType,

      extnRemarks: ewayExtendData.extnRemarks || '',
      addressLine1: ewayExtendData.addressLine1 || '',
      addressLine2: ewayExtendData.addressLine2 || '',
      addressLine3: ewayExtendData.addressLine3 || '',
    };

    console.log("Payload being sent:", payload);
    const res = await axios.post('/ewaybill/extend_vailidity_eway_bill', payload);

    setSnackbarMessage(res.data.message);
    setSnackbarSeverity(res.data.status ? "success" : "error");
    setSnackbarOpen(true);

    if (res.data.status) {
      setOpenEwayExtendDialog(false);
      onSubmitHandler();
    }
  } catch (err) {
    setSnackbarMessage(err?.response?.data?.message || "Extend validity failed");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }
};

  const columns = [
    ...(formValues.invoiceType === 'E-Invoice' ? [
      {
        field: 'select',
        headerName: '',
        flex: 0.5,
        minWidth: 50,
        align: 'center',
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
        renderHeader: (params) => {
          const rowCount = records.length;
          return (
            <Checkbox
              indeterminate={rowCount > 0 && selectedRecords.length > 0 && selectedRecords.length < rowCount}
              checked={rowCount > 0 && selectedRecords.length === rowCount}
              onChange={handleSelectAll}
              color="primary"
              size="medium"
              style={{ color: '#fff' }}
            />
          );
        },
        renderCell: (params) => {
          const record = params.row;
          const isSelected = selectedRecords.includes(record.id) && record.einvoice_status !== 'Cancelled';
          const isDisabled =
            record.einvoice_status === 'Cancelled' ||
            loadingIds.includes(record.id);

          return (
            <Checkbox
              checked={isSelected}
              onChange={(event) => {
                if (event.target.checked && record.einvoice_status !== 'Cancelled') {
                  setSelectedRecords([...selectedRecords, record.id]);
                } else {
                  setSelectedRecords(selectedRecords.filter((id) => id !== record.id));
                }
                console.log('Checkbox changed for row:', record.id, event.target.checked);
              }}
              disabled={isDisabled}
              color="primary"
              size="medium"
            />
          );
        },
      },
    ] : []),
    {
      field: 'inv_det_gstin',
      headerName: 'GSTIN',
      flex: 1,
      minWidth: 150,
      align: 'left',
      filterable: true,
    },
    {
      field: 'inv_det_legal_name',
      headerName: 'Legal Name',
      flex: 1,
      minWidth: 200,
      align: 'left',
      filterable: true,
    },
    {
      field: 'inv_det_category',
      headerName: 'Category',
      flex: 0.7,
      minWidth: 120,
      pinned: 'left',
      align: 'left',
      filterable: true,
    },
    {
      field: 'inv_det_reverse_charge',
      headerName: 'RCM',
      flex: 1,
      minWidth: 180,
      align: 'left',
      filterable: true,
    },
    {
      field: 'inv_det_document_type',
      headerName: 'Document Type',
      flex: 1,
      minWidth: 180,
      align: 'left',
      filterable: true,
    },
    {
      field: 'inv_det_document_number',
      headerName: 'Document No',
      flex: 1,
      minWidth: 180,
      align: 'left',
      filterable: true,
    },
    {
      field: 'inv_det_document_date',
      headerName: 'Document Date',
      flex: 1,
      minWidth: 180,
      align: 'left',
      filterable: true,
    },
    {
      field: 'amount_det_taxable_value',
      headerName: 'Taxable value Amount',
      flex: 1,
      minWidth: 180,
      align: 'left',
      filterable: true,
    },
    {
      field: 'total_tax_value',
      headerName: 'Total Tax Value',
      flex: 1,
      minWidth: 180,
      align: 'left',
      filterable: true,
    },
    {
      field: 'amount_det_total_item_amount',
      headerName: 'Total Item Amount',
      flex: 1,
      minWidth: 180,
      align: 'left',
      filterable: true,
    },
    ...(formValues.invoiceType === 'E-Invoice' ? [
      {
        field: 'einvoice_status',
        headerName: 'Status',
        flex: 1,
        minWidth: 150,
        filterable: true,
        renderCell: (params) => params.row.einvoice_status || 'N/A',
      },
      {
        field: 'push_to_irn',
        headerName: formValues.invoiceType === 'E-Way Bill' ? 'Push to E-way Bill' : 'Push to IRN',
        flex: 1,
        minWidth: 200,
        filterable: true,
        renderCell: (params) => {
          const record = params.row;
          const isPushDisabled = record.einvoice_status === 'Cancelled' || record.einvoice_status === 'Generated' || loadingIds.includes(record.id);

          const isRefreshDisabled =
            record.einvoice_status === 'Cancelled' ||
            record.einvoice_status === 'Generated' ||
            !record.task_id ||
            loadingIds.includes(record.id);

          console.log('Row data:', {
            id: record.id,
            task_id: record.task_id,
            status: record.einvoice_status,
            isRefreshDisabled
          });

          return (
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {loadingIds.includes(record.id) ? (
                <CircularProgress size={24} style={{ color: '#0e1375' }} />
              ) : (
                <>
                  <Tooltip title={formValues.invoiceType === 'E-Way Bill' ? 'Push to E-way Bill' : 'Push to IRN'}>
                    <span>
                      <IconButton
                        onClick={() => pushToIRN(record.id)}
                        style={{
                          color: '#0e1375',
                          filter: isPushDisabled ? 'blur(0.2px)' : 'none',
                          cursor: isPushDisabled ? 'not-allowed' : 'pointer',
                          opacity: isPushDisabled ? 0.6 : 1,
                        }}
                        disabled={isPushDisabled}
                        size="medium"
                      >
                        <QueuePlayNextIcon fontSize="medium" />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title={
                    record.einvoice_status === 'Generated'
                      ? "Invoice already generated"
                      : !record.task_id
                        ? "No task ID available - Push to IRN first"
                        : "Refresh Status"
                  }>
                    {/* <span>
                      <IconButton
                        onClick={() => refreshTaskStatus(record.id, record.inv_det_document_number, record.task_id)}
                        style={{
                          color: '#1976d2',
                          filter: isRefreshDisabled ? 'blur(0.2px)' : 'none',
                          cursor: isRefreshDisabled ? 'not-allowed' : 'pointer',
                          opacity: isRefreshDisabled ? 0.6 : 1,
                        }}
                        disabled={isRefreshDisabled}
                        size="medium"
                      >
                        <RefreshIcon fontSize="medium" />
                      </IconButton>
                    </span> */}
                  </Tooltip>
                </>
              )}
            </div>
          );
        },
      },
      {
        field: 'cancel',
        headerName: 'Cancel',
        flex: 1,
        minWidth: 150,
        filterable: true,
        renderCell: (params) => {
          const record = params.row;
          const isDisabled = record.einvoice_status === 'Cancelled' || record.einvoice_status === 'Pending' || !record.time_left || loadingIds.includes(record.id);
          console.log(`Row ID: ${record.id}, isDisabled: ${isDisabled}, Status: ${record.einvoice_status}, Time Left: ${record.time_left}, Loading IDs: ${loadingIds}`);
          return (
            <Tooltip title={record.cancel_time_remaining || ''}>
              <span>
                <Button
                  onClick={() => cancelInvoice(record.id)}
                  style={{
                    whiteSpace: 'nowrap',
                    color: 'red',
                    filter: isDisabled ? 'blur(0.2px)' : 'none',
                    opacity: isDisabled ? 0.6 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }}
                  disabled={isDisabled}
                >
                  {anotherloading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <>
                      <CancelIcon style={{ marginRight: '4px' }} />
                    </>
                  )}
                </Button>
              </span>
            </Tooltip>
          );
        },
      }
    ] : []),
    ...(formValues.invoiceType === 'E-Way Bill' ? [
      {
        field: 'push_to_portal',
        headerName: 'Push to Portal',
        flex: 1,
        minWidth: 150,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          const record = params.row;
          const isDisabled =
            record.eway_bill_pushed === true ||
            loadingIds.includes(record.id);

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {loadingIds.includes(record.id) ? (
                <CircularProgress size={24} style={{ color: '#0e1375' }} />
              ) : (
                <Tooltip title="Push to Portal">
                  <span>
                    <IconButton
                      onClick={() => pushToPortal(record.id)}
                      disabled={isDisabled}
                      size="medium"
                      style={{
                        color: '#0e1375',
                        opacity: isDisabled ? 0.4 : 1,
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <CloudUploadIcon fontSize="medium" />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
            </div>
          );
        },
      },
      {
        field: 'eway_cancel',
        headerName: 'Cancel',
        flex: 1,
        minWidth: 120,
        sortable: false,
        renderCell: (params) => {
          const row = params.row;

          const isDisabled =
            !row.eway_bill_no ||
            !row.eway_bill_pushed;

          return (
            <Tooltip title="Cancel E-Way Bill">
              <span>
                <IconButton
                  onClick={() => openEwayCancelPopup(row)}
                  disabled={isDisabled}
                  size="medium"
                  style={{
                    color: '#d32f2f',
                    opacity: isDisabled ? 0.4 : 1
                  }}
                >
                  <CancelIcon fontSize="medium" />
                </IconButton>
              </span>
            </Tooltip>
          );
        }
      }

    ] : []),
    {
      field: 'eway_extend',
      headerName: 'Extend Validity',
      flex: 1,
      minWidth: 140,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;
        const isDisabled = !row.eway_bill_no || !row.eway_bill_pushed;
        return (
          <Tooltip title="Extend E-Way Bill Validity">
            <span>
              <IconButton
                onClick={() => openEwayExtendPopup(row)}
                disabled={isDisabled}
                size="medium"
                style={{
                  color: '#1976d2',
                  opacity: isDisabled ? 0.4 : 1,
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                }}
              >
                <RefreshIcon fontSize="medium" />
              </IconButton>
            </span>
          </Tooltip>
        );
      }
    },

    {
      field: 'actions',
      headerName: 'Action',
      flex: 1,
      minWidth: 100,
      align: 'left',
      renderCell: (params) => {
        const record = params.row;
        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <IconButton
              size="medium"
              onClick={() =>
                formValues.invoiceType === 'E-Invoice'
                  ? downloadInvoice(record.id)
                  : formValues.invoiceType === 'E-Way Bill'
                    ? downloadEwayBillPdf(record)
                  : downloadInvoicetax(record.id)
              }
              style={{
                color: '#4F7942',
                cursor: (
                  formValues.invoiceType === 'E-Way Bill'
                    ? (!record.eway_bill_no || !record.eway_bill_pushed)
                    : record.einvoice_status === 'Pending'
                ) ? 'not-allowed' : 'pointer',
                opacity: (
                  formValues.invoiceType === 'E-Way Bill'
                    ? (!record.eway_bill_no || !record.eway_bill_pushed)
                    : record.einvoice_status === 'Pending'
                ) ? 0.5 : 1,
              }}
              disabled={
                formValues.invoiceType === 'E-Way Bill'
                  ? (!record.eway_bill_no || !record.eway_bill_pushed)
                  : record.einvoice_status === 'Pending'
              }
              title="Download"
            >
              <DownloadIcon fontSize="medium" />
            </IconButton>
          </div>
        );
      },
      filterable: false,
    },
  ];

  const CustomToolbar = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        height: '60px',
        flexWrap: 'wrap',
        gap: 1,
        padding: '3px 10px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <GridToolbarColumnsButton
          sx={{
            variant: 'outlined',
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': {
              borderColor: '#1565c0',
              backgroundColor: '#e3f2fd',
            }
          }}
        />
        <GridToolbarFilterButton
          sx={{
            variant: 'outlined',
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': {
              borderColor: '#1565c0',
              backgroundColor: '#e3f2fd',
            }
          }}
        />
        <GridToolbarDensitySelector
          sx={{
            variant: 'outlined',
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': {
              borderColor: '#1565c0',
              backgroundColor: '#e3f2fd',
            }
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {formValues.invoiceType === 'E-Invoice' && (
          <Button
            variant="outlined"
            style={{
              color: '#1976d2',
              borderColor: '#1976d2',
              borderRadius: '4px',
              padding: '2px 10px',
              height: '30px',
              minHeight: 'unset'
            }}
            onClick={handleAddButtonClick}
            disabled={loading}
            size="small"
          >
            {loading ? <CircularProgress size={18} /> : (
              <>
                <QueuePlayNextIcon style={{ marginRight: '4px', fontSize: '18px' }} /> BULK GENERATE
              </>
            )}
          </Button>
        )}
        {formValues.invoiceType === 'E-Invoice' && (
          <Button
            variant="outlined"
            style={{
              color: '#d32f2f',
              borderColor: '#d32f2f',
              borderRadius: '4px',
              padding: '2px 10px',
              height: '30px',
              minHeight: 'unset'
            }}
            onClick={handleSecondButtonClick}
            disabled={anotherloading}
            size="small"
          >
            {anotherloading ? <CircularProgress size={18} /> : (
              <>
                <DeleteIcon style={{ marginRight: '4px', fontSize: '18px' }} /> BULK CANCELLATION
              </>
            )}
          </Button>
        )}
        <Button
          variant="outlined"
          disabled={!records || records.length === 0}
          style={{
            color: '#26A69A',
            borderRadius: '4px',
            textTransform: 'none',
            padding: '2px 10px',
            borderColor: '#26A69A',
            height: '30px',
            minHeight: 'unset'
          }}
          onClick={handleExportExcel}
          size="small"
        >
          <DownloadIcon style={{ marginRight: '4px', fontSize: '18px' }} /> EXPORT
        </Button>
      </Box>
    </Box>
  );

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  useEffect(() => {
    setFromDateMonthYearDisplay(null);
    setToDateMonthYearDisplay(null);
    setRecords([]);
    setFilteredData([]);
  }, [formValues.invoiceType]);

  useEffect(() => {
    const businessEntityId = localStorage.getItem('business_entity_id');
    // const getEinvoiceData = () => {
    //   axios
    //     .get(`/einvoice/get_conn_details/${businessEntityId}/`)
    //     .then((res) => {
    //       const username = res.data.records[0]?.username || '';
    //       const password = res.data.records[0]?.password || '';
    //       const gstin = res.data.records[0]?.gstin || '';
    //       setEinvoiceData(res.data.records);

    //       // Save data to localStorage
    //       localStorage.setItem('username', username);
    //       localStorage.setItem('password', password);
    //       localStorage.setItem('gstin', gstin);
    //     })
    //     .catch((error) => {
    //       setEinvoiceData([]);

    //     });
    // };

    // getEinvoiceData(); // Call the function when the component mounts
  }, []);

  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumSignificantDigits: 10,
    }).format(value);

  const handleExportExcel = () => {
    const bid = localStorage.getItem('business_entity_id');
    const fileName = formValues.invoiceType === 'Tax Invoice'
      ? 'Tax Invoice Summary'
      : 'E-Invoice Summary';
    const payload = {
      invoice_type: formValues.invoiceType,
      from_date: moment(fromDateMonthYearDisplay).format("YYYY-MM-DD"),
      to_date: moment(toDateMonthYearDisplay).format("YYYY-MM-DD"),
      business_entity_id: localStorage.getItem('business_entity_id')
    }

    if (bid) {
      const url = `/einvoice/download_einvoice_summary`;

      axios.post(url, payload)
        .then(response => {
          const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const base64Data = response.data.file;
          downloadBase64File(contentType, base64Data, `${fileName}.xlsx`);
        })
        .catch(error => {
          console.error("Error exporting file:", error);
        });
    } else {
      console.error('Business entity ID not found in localStorage');
    }
  };

  const inputHandlerFromDatePicker = (date) => {
    setFromDateMonthYearDisplay(date);
  };

  const inputHandlerToDatePicker = (date) => {
    setToDateMonthYearDisplay(date);
  };

  const handleOpenAndCloseModel = () => {
    setFromDateMonthYearDisplay(null);
    setToDateMonthYearDisplay(null);
  };


  const onSubmitHandler = async () => {
    try {
      if (!fromDateMonthYearDisplay || !toDateMonthYearDisplay) {
        setSnackbarMessage('Please select both From Date and To Date');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }

      const business_entity_id = localStorage.getItem('business_entity_id');
      const payload = {
        from_date: moment(fromDateMonthYearDisplay).format("YYYY-MM-DD"),
        to_date: moment(toDateMonthYearDisplay).format("YYYY-MM-DD"),
        business_entity_id: business_entity_id,
        invoice_type: formValues.invoiceType,
      };

      // ────────────────────────────────────────────────
      // We'll handle polling inside its own function
      // ────────────────────────────────────────────────
      await fetchAndCheckStatus(payload);

    } catch (error) {
      if (error.response?.data?.message) {
        setSnackbarMessage(`Error: ${error.response.data.message}`);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      } else {
        console.error(error);
      }
    }
  };

  // ──────────────────────────────────────────────────────────────
  // Separate function that can call itself recursively via interval
  // ──────────────────────────────────────────────────────────────
  const fetchAndCheckStatus = async (payload) => {
    try {
      const response = await axios.post('/einvoice/get_tax_data_by_date', payload);

      if (response.status !== 200 || !response.data?.status) {
        throw new Error('Failed to fetch data');
      }

      const records = response.data.records || [];
      setRecords(records);
      setFilteredData(records);

      const hasInProgress = records.some(
        (record) => record.einvoice_status === "In-Progress"
      );

      if (hasInProgress) {
        setSnackbarMessage("E-invoice generation in progress. Refreshing automatically...");
        setSnackbarSeverity("info");
        setSnackbarOpen(true);

        const timer = setTimeout(() => {
          fetchAndCheckStatus(payload);
        }, 15000);

        return () => clearTimeout(timer);
      }

    } catch (err) {
      console.error("Polling error:", err);
    }
  };

  // const onSubmitHandler = async () => {
  //   try {
  //     if (!fromDateMonthYearDisplay || !toDateMonthYearDisplay) {
  //       setSnackbarMessage('Please select both From Date and To Date');
  //       setSnackbarSeverity('error');
  //       setSnackbarOpen(true);
  //       return;
  //     }
  //     const business_entity_id = localStorage.getItem('business_entity_id');

  //     const payload = {
  //       from_date: moment(fromDateMonthYearDisplay).format("YYYY-MM-DD"),
  //       to_date: moment(toDateMonthYearDisplay).format("YYYY-MM-DD"),
  //       business_entity_id: business_entity_id,
  //       invoice_type: formValues.invoiceType
  //     };

  //     const response = await axios.post('/einvoice/get_tax_data_by_date', payload);
  //     const resStatus = response.data.records
  //     console.log(resStatus.einvoice_status);

  //     if (resStatus.einvoice_status=== "In-Progress") {
  //       alert("messge")
  //     }

  //     if (response.status === 200 && response.data.status) {
  //       setRecords(response.data.records);
  //       setFilteredData(response.data.records)
  //     } else {
  //       throw new Error('Failed to fetch data');
  //     }
  //   } catch (error) {
  //     if (error.response && error.response.data && error.response.data.message) {
  //       setSnackbarMessage(`Error: ${error.response.data.message}`);
  //       setSnackbarSeverity('error');
  //       setSnackbarOpen(true);
  //     }
  //   }
  // };

  const handleDropdownClick = (setter) => (event) => {
    setter(event.currentTarget);
  };

  const handleDropdownClose = (setter, updater) => (value) => {
    if (value) {
      updater(value);
    }
    setter(null);
  };

  const pushToIRN = (id) => {
    setLoadingIds(prev => [...prev, id]);
    const business_entity_id = localStorage.getItem('business_entity_id');
    const user_id = localStorage.getItem('user_id')
    const status = "Generated";
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    const gstin = localStorage.getItem('gstin')
    const irp_number = "vay"

    console.log('Pushing to IRN for invoice ID:', id);

    axios.post('/einvoice/post_gov_portal_details', {
      id: [id],
      business_entity_id,
      username,
      password,
      gstin,
      irp_number,
      user_id,
      status
    })
      .then(response => {
        console.log('Push to IRN response:', response.data);
        setLoadingIds(prev => prev.filter(item => item !== id));

        if (response.data && response.data.records && response.data.records.task_id) {
          console.log("task", response.data.records.task_id);

          const message = response.data.message;
          const taskId = response.data.records.task_id;

          setTaskIds(prevTaskIds => {
            const updatedTaskIds = [...prevTaskIds, taskId];
            return updatedTaskIds;
          });

          let displayMessage = message;

          if (response.data.errors && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
            const errorDetails = response.data.errors.join('\n• ');
            displayMessage = `${message}\n\nValidation Errors:\n• ${errorDetails}`;
          }

          setSnackbarMessage(displayMessage);

          if (response.data.success === true ||
            response.data.status === true ||
            message.toLowerCase().includes('successfully') ||
            message.toLowerCase().includes('success')) {
            setSnackbarSeverity('success');
          } else {
            setSnackbarSeverity('error');
          }

          setSnackbarOpen(true);
        }

        console.log('Calling onSubmitHandler to refresh data');
        onSubmitHandler();
      })
      .catch(error => {
        setLoadingIds(prev => prev.filter(item => item !== id));

        let errorMessage = 'Error occurred while generating E-Invoice.';

        if (error.response && error.response.data) {
          const errorData = error.response.data;
          errorMessage = errorData.message || errorMessage;

          if (errorData.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
            const errorDetails = errorData.errors.join('\n• ');
            errorMessage = `${errorMessage}\n\nValidation Errors:\n• ${errorDetails}`;
          }
        }

        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
  }

  const pushToPortal = (id) => {
    setLoadingIds(prev => [...prev, id]);
    const business_entity_id = localStorage.getItem('business_entity_id');

    axios.post('/ewaybill/push_to_portal', {
      business_entity_id,
      tax_master_id: id
    })
      .then(response => {
        const message = response.data.message || 'Operation completed';
        setSnackbarMessage(message);
        if (response.data.status === true) {
          setSnackbarSeverity('success');
        } else {
          setSnackbarSeverity('error');
        }
        setSnackbarOpen(true);
        onSubmitHandler();
      })
      .catch(error => {
        let errorMessage = 'Error occurred while pushing to portal.';
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setLoadingIds(prev => prev.filter(item => item !== id));
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCancelClose = () => {
    setOpenDialog(false);
    setReason('');
  };

  const cancelInvoice = (id) => {
    setInvoiceIdToCancel(id);
    setDialogMessage('Please Enter the Reason');
    setOpenDialog(true);
  };


  const getLogApi = () => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    // const apiUrl = `/e_invoice_irn_logs/${business_entity_id}`;
    axios
      .get(`/e_invoice_irn_logs/${business_entity_id}`)
      .then((res) => {
        setLogData(res.data.data);
      })

  }


  const getTableLogVisibility = (row) => {
    const logid = row.log_id;
    // const apiUrl = `/e_invoice_irn_logs/${business_entity_id}`;
    axios
      .get(`/e_invoice_irn_logs_summary/${logid}`)
      .then((res) => {
        setErrorLog(res.data.data);
        setOpenPopup(true)
      })
  }

  const handleClosePopup = () => {
    setOpenPopup(false);

  };

  const handleErrorMessage = (errorMessage) => {
    // toast.error(errorMessage, {
    //   autoClose: 3000,
    //   progress: 0,
    // });
  };


  const handleCancelConfirm = () => {
    if (!reason.trim()) {
      alert('Please enter a reason for canceling the invoice.');
      return;
    }

    const business_entity_id = localStorage.getItem('business_entity_id');
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    const gstin = localStorage.getItem('gstin');
    const irp_number = 'vay';

    axios.post('/einvoice/cancel_generated_einvoice', {
      id: [invoiceIdToCancel],
      business_entity_id,
      gstin,
      reason
    })
      .then((response) => {
        console.log('Invoice canceled successfully', response.data);
        setOpenDialog(false);
        setReason('');
        setDialogMessage('');
        onSubmitHandler();

        const message = response.data.message;
        let displayMessage = message;

        if (response.data.errors && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
          const errorDetails = response.data.errors.join('\n• ');
          displayMessage = `${message}\n\nValidation Errors:\n• ${errorDetails}`;
        }

        setSnackbarMessage(displayMessage);

        if (response.data.success === true ||
          response.data.status === true ||
          message.toLowerCase().includes('successfully') ||
          message.toLowerCase().includes('success')) {
          setSnackbarSeverity('success');
        } else {
          setSnackbarSeverity('error');
        }

        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error('Error canceling the invoice', error);
        setOpenDialog(false);
        setReason('');
        setDialogMessage('');

        let errorMessage = 'Internal Server Error occurred.';

        if (error.response && error.response.data) {
          const errorData = error.response.data;
          errorMessage = errorData.message || errorMessage;

          if (errorData.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
            const errorDetails = errorData.errors.join('\n• ');
            errorMessage = `${errorMessage}\n\nValidation Errors:\n• ${errorDetails}`;
          }
        }

        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  };

  const handleClear = () => {
    setReason('');
  };

  useEffect(() => {
    console.log("Current taskIds:", taskIds);
    getLogApi()
  }, [taskIds]);

  const downloadInvoice = (id) => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    const url = `/einvoice/download_generated_einvoice/${business_entity_id}/${id}`;

    axios.get(url, { responseType: 'json' })
      .then(response => {
        const base64Data = response.data.file;
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'invoice.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => {
        console.error('Error downloading zip file:', error);
      });
  };

  const downloadEwayBillPdf = async (record) => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    const ewbNo = record.eway_bill_no;

    if (!ewbNo) {
      setSnackbarMessage('E-Way Bill number not available');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    try {
      const response = await axios.post('/ewaybill/download_the_pdf', {
        business_entity_id,
        ewbNo: String(ewbNo)
      });

      if (response.data.status === false) {
        setSnackbarMessage(response.data.message || 'Failed to download E-Way Bill PDF');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }
      if (response.data.file) {
        const byteCharacters = atob(response.data.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `EWayBill_${ewbNo}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setSnackbarMessage(response.data.message || 'Download completed');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error downloading E-Way Bill PDF';
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const downloadInvoicetax = (id) => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    const apiUrl = `/einvoice/export_normal_invoice/${business_entity_id}/${id}`;

    axios
      .get(apiUrl)
      .then((response) => {
        if (response.data && response.data.file && response.data.status === "pass") {
          const fileContent = response.data.file;
          const byteCharacters = atob(fileContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const htmlContent = new TextDecoder().decode(byteArray);
          const printWindow = window.open('', '_blank');
          printWindow.document.write(htmlContent);
          printWindow.document.close();
          printWindow.print();
        } else {
          console.error("File download failed");
        }
      })
      .catch((error) => {
        console.error("Error while downloading file:", error);
      });
  };

  const handleStatusDropdownClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setStatusAnchorEl(null);
    setRcmAnchorEl(null);
    setDocumentTypeAnchorEl(null);
    setCategoryAnchorEl(null);
  };

  const handleStatusMenuItemClick = (status) => {
    setSelectedStatus(status);
    setStatusAnchorEl(null);
  };

  const handleClearStatus = (event) => {
    event.stopPropagation();
    setSelectedStatus('STATUS');
    setStatusAnchorEl(null);
  };

  const handleRcmDropdownClick = (event) => {
    setRcmAnchorEl(event.currentTarget);
  };

  const handleRcmMenuItemClick = (rcm) => {
    setSelectedRcm(rcm);
    setRcmAnchorEl(null);
  };

  const handleClearRcm = (event) => {
    event.stopPropagation();
    setSelectedRcm('RCM');
    setRcmAnchorEl(null);
  };

  const handleDocumentTypeDropdownClick = (event) => {
    setDocumentTypeAnchorEl(event.currentTarget);
  };

  const handleDocumentTypeMenuItemClick = (docType) => {
    setSelectedDocumentType(docType);
    setDocumentTypeAnchorEl(null);
  };

  const handleClearDocumentType = (event) => {
    event.stopPropagation();
    setSelectedDocumentType('DOCUMENT TYPE');
    setDocumentTypeAnchorEl(null);
  };

  const handleCategoryDropdownClick = (event) => {
    setCategoryAnchorEl(event.currentTarget);
  };

  const handleCategoryMenuItemClick = (category) => {
    setSelectedCategory(category);
    setCategoryAnchorEl(null);
  };

  const handleClearCategory = (event) => {
    event.stopPropagation();
    setSelectedCategory('CATEGORY');
    setCategoryAnchorEl(null);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  }

  const filterData = () => {
    if (!searchInput) {
      setFilteredData(records);
      return;
    }
    const filtered = filteredData.filter(record => {
      const customerName = (record['inv_det_legal_name'] || '').toLowerCase();
      const customerPan = (record['inv_det_gstin'] || '').toLowerCase();
      const searchTerm = searchInput.toLowerCase();
      const category = (record['inv_det_category'] || '').toLowerCase();
      const reverseCharge = (record['inv_det_reverse_charge'] || '').toLowerCase();
      const documentType = (record['inv_det_document_type'] || '').toLowerCase();
      const documentNumber = (record['inv_det_document_number'] || '').toLowerCase();
      const documentDate = (record['inv_det_document_date'] || '').toLowerCase();
      const taxableValue = (record['amount_det_taxable_value'] || '').toString();
      const totalTaxValue = (record['total_tax_value'] || '').toString();
      const totalItemAmount = (record['amount_det_total_item_amount'] || '').toString();
      const einvoiceStatus = (record['einvoice_status'] || '').toLowerCase();

      return (
        customerName.includes(searchTerm) ||
        customerPan.includes(searchTerm) ||
        category.includes(searchTerm) ||
        reverseCharge.includes(searchTerm) ||
        documentType.includes(searchTerm) ||
        documentNumber.includes(searchTerm) ||
        documentDate.includes(searchTerm) ||
        taxableValue.includes(searchTerm) ||
        totalTaxValue.includes(searchTerm) ||
        totalItemAmount.includes(searchTerm) ||
        einvoiceStatus.includes(searchTerm)
      );
    });
    setFilteredData(filtered);
  };

  useEffect(() => {
    filterData()
  }, [searchInput, records])

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const filteredRecords = filteredData.filter(record =>
    (selectedStatus === 'STATUS' || record.einvoice_status === selectedStatus) &&
    (selectedDocumentType === 'DOCUMENT TYPE' || record.inv_det_document_type === selectedDocumentType) &&
    (selectedRcm === 'RCM' || record.inv_det_reverse_charge === selectedRcm) &&
    (selectedCategory === 'CATEGORY' || record.inv_det_category === selectedCategory)
  );

  return (
    <>
      <Paper
        elevation={3}
        style={{
          padding: '10px',
          margin: '20px',
          borderRadius: '8px',
          maxWidth: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Typography variant="h6" style={{ fontWeight: 'bold', marginLeft: '18px', }}>
          E-INVOICE SUMMARY
        </Typography>

        <ValidatorForm
          useRef="form"
          onSubmit={onSubmitHandler}
          onError={(errors) => console.log(errors)}
        >
          <Grid container >
            <Grid item xs={12} spacing={3}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  flexWrap: 'wrap',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px',
                    marginLeft: '18px',
                    marginTop: '3%',
                  }}
                >
                  <FormControl fullWidth variant="outlined" size="small" sx={{ width: '200px', margin: '20px 0' }}>
                    <InputLabel id="invoice-type-label">Invoice Type</InputLabel>
                    <Select
                      labelId="invoice-type-label"
                      id="invoice-type"
                      value={formValues.invoiceType}
                      onChange={(e) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          invoiceType: e.target.value,
                        }))
                      }
                      label="Invoice Type"
                    >
                      <MenuItem value="Tax Invoice">Tax Invoice</MenuItem>
                      <MenuItem value="E-Invoice">E-Invoice</MenuItem>
                      <MenuItem value="E-Way Bill">E-Way Bill</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div style={{ minWidth: '200px' }}>
                  <label style={{ margin: 0, fontWeight: 500 }}>
                    From Date<span style={{ color: 'red' }}>*</span>:
                  </label>
                  <Date
                    placeholder="From Date"
                    errorMessages={['This field is required']}
                    validators={['required']}
                    value={fromDateMonthYearDisplay ?? ''}
                    onChange={(v) => inputHandlerFromDatePicker(v)}
                    style={{ width: '150px', marginTop: '8px' }}
                  />
                </div>
                <div style={{ minWidth: '200px' }}>
                  <label style={{ margin: 0, fontWeight: 500 }}>
                    To Date<span style={{ color: 'red' }}>*</span>:
                  </label>
                  <Date
                    minDateForDatepicker={fromDateMonthYearDisplay ?? ''}
                    placeholder="To Date"
                    errorMessages={['This field is required']}
                    validators={['required']}
                    value={toDateMonthYearDisplay ?? ''}
                    onChange={(v) => inputHandlerToDatePicker(v)}
                    style={{ width: '150px', marginTop: '8px' }}
                  />
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ height: '36px', marginTop: '16px', padding: '6px 16px' }}
                >
                  SUBMIT
                </Button>
              </div>
            </Grid>
          </Grid>
        </ValidatorForm>
      </Paper>

      <DataGridPro
        rows={records}
        columns={columns}
        loading={form16DataLoading}
        autoHeight
        getRowId={(row) => row.id}
        localeText={{
          toolbarDensity: 'Size',
          toolbarDensityLabel: 'Size',
          toolbarDensityCompact: 'Small',
          toolbarDensityStandard: 'Medium',
          toolbarDensityComfortable: 'Large',
          noRowsLabel: 'No records found',
        }}
        slots={{
          noRowsOverlay: () => (
            <Typography
              variant="body1"
              style={{
                textAlign: 'center',
                padding: '20px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              No data available. Please submit a date range to fetch records.
            </Typography>
          ),
        }}
        sx={{
          width: '100%',
          '& .MuiDataGrid-columnHeaders': {
            color: '#fff',
            fontWeight: 'bold',
            cursor: 'pointer',
            textAlign: 'right',
            zIndex: 1000,
            backgroundColor: '#607d8b',
          },
          '& .MuiDataGrid-columnHeader': {
            position: 'relative',
            textAlign: 'right',
            fontWeight: 'bold',
            backgroundColor: '#607d8b',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: '#fff',
          },
          '& .MuiDataGrid-sortIcon': {
            opacity: 'inherit !important',
          },
          '& .MuiDataGrid-iconButtonContainer': {
            visibility: 'visible',
          },
          '& .MuiDataGrid-menuIconButton': {
            opacity: '1 !important',
            visibility: 'visible !important',
            display: 'flex !important',
          },
          '& .MuiDataGrid-columnHeaderIcon': {
            color: '#fff',
          },
          '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
            color: '#fff',
          },
          '& .MuiDataGrid-row:nth-of-type(odd)': {
            backgroundColor: '#f9f9f9',
          },
          '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: '#ffffff',
          },
          '& .MuiDataGrid-cell': {
            padding: '8px',
            textAlign: 'center',
          },
          '& .MuiDataGrid-footerContainer': {
            backgroundColor: '#f0f0f0',
          },
          '& .MuiCheckbox-root': {
            color: '#1976d2',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#d3e3fc',
            cursor: 'pointer',
          },
        }}
        pagination
        pageSize={5}
        pageSizeOptions={[5, 10, 25, 50]}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <Dialog
        open={openEwayCancelDialog}
        onClose={() => setOpenEwayCancelDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: "4px",
            padding: "0",
            border: "1px solid #c5cae3",
            overflow: "hidden"
          }
        }}
      >
        {/* Header */}
        <DialogTitle
          style={{
            background: "#1a3566",
            color: "#fff",
            fontSize: "15px",
            fontWeight: "500",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          Cancel E-Way Bill
          <IconButton
            size="small"
            onClick={() => setOpenEwayCancelDialog(false)}
            style={{ color: "rgba(255,255,255,0.75)", padding: "2px" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ padding: "20px 20px 12px" }}>

          {/* EWB No */}
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              E-Way Bill No
            </Typography>
            <TextField
              value={ewayCancelData.ewbNo}
              fullWidth
              disabled
              variant="outlined"
              size="small"
              InputProps={{
                style: {
                  fontSize: "13px",
                  background: "#f5f6fa",
                  borderRadius: "3px"
                }
              }}
              style={{ marginTop: "5px" }}
            />
          </Box>

          {/* Reason */}
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              Reason <span style={{ color: "#e24b4a" }}>*</span>
            </Typography>
            <FormControl fullWidth size="small" style={{ marginTop: "5px" }}>
              <Select
                value={ewayCancelData.cancelRsnCode}
                displayEmpty
                onChange={(e) =>
                  setEwayCancelData(prev => ({
                    ...prev,
                    cancelRsnCode: e.target.value
                  }))
                }
                style={{ fontSize: "13px", borderRadius: "3px" }}
              >
                <MenuItem value=""><em style={{ color: "#9ca3af" }}>-- Select Reason --</em></MenuItem>
                <MenuItem value={1}>Duplicate</MenuItem>
                <MenuItem value={2}>Order Cancelled</MenuItem>
                <MenuItem value={3}>Data Entry Mistake</MenuItem>
                <MenuItem value={4}>Others</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Remark */}
          <Box>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              Remark
            </Typography>
            <TextField
              multiline
              rows={3}
              value={ewayCancelData.cancelRmrk}
              onChange={(e) =>
                setEwayCancelData(prev => ({
                  ...prev,
                  cancelRmrk: e.target.value
                }))
              }
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter remark..."
              InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
              style={{ marginTop: "5px" }}
            />
          </Box>
        </DialogContent>

        {/* Actions */}
        <DialogActions
          style={{
            padding: "12px 20px 16px",
            borderTop: "1px solid #e8eaf2",
            gap: "8px"
          }}
        >
          <Button
            onClick={handleClearEwayCancel}
            variant="outlined"
            size="small"
            style={{
              fontSize: "13px",
              fontWeight: 500,
              borderRadius: "3px",
              borderColor: "#c5cae3",
              color: "#6b7280",
              textTransform: "uppercase"
            }}
          >
            Clear
          </Button>
          <Button
            onClick={submitEwayCancel}
            variant="contained"
            size="small"
            style={{
              fontSize: "13px",
              fontWeight: 500,
              borderRadius: "3px",
              backgroundColor: "#1a3566",
              color: "#fff",
              textTransform: "uppercase"
            }}
          >
            Submit
          </Button>
          <Button
            onClick={() => setOpenEwayCancelDialog(false)}
            variant="outlined"
            size="small"
            style={{
              fontSize: "13px",
              fontWeight: 500,
              borderRadius: "3px",
              borderColor: "#c5cae3",
              color: "#6b7280",
              textTransform: "uppercase"
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* ---E-Way Bill Extend Validity Dialog--- */}
      {/* ---E-Way Bill Extend Validity Dialog--- */}
      <Dialog
        open={openEwayExtendDialog}
        onClose={() => setOpenEwayExtendDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: "4px",
            padding: "0",
            border: "1px solid #c5cae3",
            overflow: "hidden"
          }
        }}
      >
        <DialogTitle
          style={{
            background: "#1a3566",
            color: "#fff",
            fontSize: "15px",
            fontWeight: "500",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          Extend E-Way Bill Validity
          <IconButton
            size="small"
            onClick={() => setOpenEwayExtendDialog(false)}
            style={{ color: "rgba(255,255,255,0.75)", padding: "2px" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ padding: "20px 20px 12px" }}>

          {/* EWB No */}
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              E-Way Bill No
            </Typography>
            <TextField
              value={ewayExtendData.ewbNo}
              fullWidth disabled variant="outlined" size="small"
              InputProps={{ style: { fontSize: "13px", background: "#f5f6fa", borderRadius: "3px" } }}
              style={{ marginTop: "5px" }}
            />
          </Box>

          {/* Vehicle No */}
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              Vehicle No <span style={{ color: "#e24b4a" }}>*</span>
            </Typography>
            <TextField
              value={ewayExtendData.vehicleNo}
              onChange={(e) => setEwayExtendData(prev => ({ ...prev, vehicleNo: e.target.value }))}
              fullWidth variant="outlined" size="small" placeholder="e.g. PQR1234"
              InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
              style={{ marginTop: "5px" }}
            />
          </Box>

          {/* From Place & From Pincode */}
          <Box mb={2} style={{ display: "flex", gap: "12px" }}>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                From Place <span style={{ color: "#e24b4a" }}>*</span>
              </Typography>
              <TextField
                value={ewayExtendData.fromPlace}
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, fromPlace: e.target.value }))}
                fullWidth variant="outlined" size="small" placeholder="e.g. Bengaluru"
                InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
                style={{ marginTop: "5px" }}
              />
            </Box>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                From Pincode <span style={{ color: "#e24b4a" }}>*</span>
              </Typography>
              <TextField
                value={ewayExtendData.fromPincode}
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, fromPincode: e.target.value }))}
                fullWidth variant="outlined" size="small" placeholder="e.g. 560090"
                InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
                style={{ marginTop: "5px" }}
              />
            </Box>
          </Box>

          {/* From State & Remaining Distance */}
          <Box mb={2} style={{ display: "flex", gap: "12px" }}>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                From State <span style={{ color: "#e24b4a" }}>*</span>
              </Typography>
              <TextField
                value={ewayExtendData.fromState}
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, fromState: e.target.value }))}
                fullWidth variant="outlined" size="small" placeholder="e.g. 29"
                InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
                style={{ marginTop: "5px" }}
              />
            </Box>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                Remaining Distance (km)
              </Typography>
              <TextField
                value={ewayExtendData.remainingDistance}
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, remainingDistance: e.target.value }))}
                fullWidth variant="outlined" size="small" placeholder="e.g. 50"
                InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
                style={{ marginTop: "5px" }}
              />
            </Box>
          </Box>

          {/* Trans Doc No & Trans Doc Date */}
          <Box mb={2} style={{ display: "flex", gap: "12px" }}>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                Trans Doc No
              </Typography>
              <TextField
                value={ewayExtendData.transDocNo}
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, transDocNo: e.target.value }))}
                fullWidth variant="outlined" size="small"
                InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
                style={{ marginTop: "5px" }}
              />
            </Box>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                Trans Doc Date
              </Typography>
              <TextField
                type="date"
                value={ewayExtendData.transDocDate}
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, transDocDate: e.target.value }))}
                fullWidth variant="outlined" size="small"
                InputLabelProps={{ shrink: true }}
                InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
                style={{ marginTop: "5px" }}
              />
            </Box>
          </Box>

          {/* Trans Mode & Transit Type */}
          <Box mb={2} style={{ display: "flex", gap: "12px" }}>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                Trans Mode
              </Typography>
              <FormControl fullWidth size="small" style={{ marginTop: "5px" }}>
                <Select
                  value={ewayExtendData.transMode}
                  onChange={(e) => setEwayExtendData(prev => ({ ...prev, transMode: e.target.value }))}
                  style={{ fontSize: "13px", borderRadius: "3px" }}
                >
                  <MenuItem value="1">Road</MenuItem>
                  <MenuItem value="2">Rail</MenuItem>
                  <MenuItem value="3">Air</MenuItem>
                  <MenuItem value="4">Ship</MenuItem>
                  {/* <MenuItem value="5">In Transit</MenuItem> */}
                </Select>
              </FormControl>
            </Box>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
                Transit Type
              </Typography>
              <FormControl fullWidth size="small" style={{ marginTop: "5px" }}>
                <Select
                  value={ewayExtendData.transitType}
                  onChange={(e) => setEwayExtendData(prev => ({ ...prev, transitType: e.target.value }))}
                  style={{ fontSize: "13px", borderRadius: "3px" }}
                >
                  <MenuItem value="R">Regular</MenuItem>
                  <MenuItem value="T">ODC</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          {/* Reason */}
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              Reason for Extension <span style={{ color: "#e24b4a" }}>*</span>
            </Typography>
            <FormControl fullWidth size="small" style={{ marginTop: "5px" }}>
              <Select
                value={ewayExtendData.extnRsnCode}
                displayEmpty
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, extnRsnCode: e.target.value }))}
                style={{ fontSize: "13px", borderRadius: "3px" }}
              >
                <MenuItem value=""><em style={{ color: "#9ca3af" }}>-- Select Reason --</em></MenuItem>
                <MenuItem value={1}>Natural Calamity</MenuItem>
                <MenuItem value={2}>Law and Order Situation</MenuItem>
                <MenuItem value={3}>Transshipment</MenuItem>
                <MenuItem value={4}>Accident</MenuItem>
                <MenuItem value={5}>Others</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {/* Consignment Status */}
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              Consignment Status
            </Typography>
            <FormControl fullWidth size="small" style={{ marginTop: "5px" }}>
              <Select
                value={ewayExtendData.consignmentStatus}
                displayEmpty
                onChange={(e) => setEwayExtendData(prev => ({ ...prev, consignmentStatus: e.target.value }))}
                style={{ fontSize: "13px", borderRadius: "3px" }}
              >
                <MenuItem value=""><em style={{ color: "#9ca3af" }}>-- Select Status --</em></MenuItem>
                <MenuItem value="T">In Transit</MenuItem>
                <MenuItem value="M">In Movement</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Address Lines */}
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>Address Line 1</Typography>
            <TextField value={ewayExtendData.addressLine1} onChange={(e) => setEwayExtendData(prev => ({ ...prev, addressLine1: e.target.value }))}
              fullWidth variant="outlined" size="small" InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }} style={{ marginTop: "5px" }} />
          </Box>
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>Address Line 2</Typography>
            <TextField value={ewayExtendData.addressLine2} onChange={(e) => setEwayExtendData(prev => ({ ...prev, addressLine2: e.target.value }))}
              fullWidth variant="outlined" size="small" InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }} style={{ marginTop: "5px" }} />
          </Box>
          <Box mb={2}>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>Address Line 3</Typography>
            <TextField value={ewayExtendData.addressLine3} onChange={(e) => setEwayExtendData(prev => ({ ...prev, addressLine3: e.target.value }))}
              fullWidth variant="outlined" size="small" InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }} style={{ marginTop: "5px" }} />
          </Box>

          {/* Remarks */}
          <Box>
            <Typography variant="caption" style={{ color: "#6b7280", fontWeight: 500, letterSpacing: "0.3px", textTransform: "uppercase" }}>
              Remarks
            </Typography>
            <TextField
              multiline rows={2}
              value={ewayExtendData.extnRemarks}
              onChange={(e) => setEwayExtendData(prev => ({ ...prev, extnRemarks: e.target.value }))}
              fullWidth variant="outlined" size="small" placeholder="e.g. Flood"
              InputProps={{ style: { fontSize: "13px", borderRadius: "3px" } }}
              style={{ marginTop: "5px" }}
            />
          </Box>

        </DialogContent>

        <DialogActions style={{ padding: "12px 20px 16px", borderTop: "1px solid #e8eaf2", gap: "8px" }}>
          <Button onClick={handleClearEwayExtend} variant="outlined" size="small"
            style={{ fontSize: "13px", fontWeight: 500, borderRadius: "3px", borderColor: "#c5cae3", color: "#6b7280", textTransform: "uppercase" }}>
            Clear
          </Button>
          <Button onClick={submitEwayExtend} variant="contained" size="small"
            style={{ fontSize: "13px", fontWeight: 500, borderRadius: "3px", backgroundColor: "#1a3566", color: "#fff", textTransform: "uppercase" }}>
            Submit
          </Button>
          <Button onClick={() => setOpenEwayExtendDialog(false)} variant="outlined" size="small"
            style={{ fontSize: "13px", fontWeight: 500, borderRadius: "3px", borderColor: "#c5cae3", color: "#6b7280", textTransform: "uppercase" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <BoxWrapper boxTitle="E-invoice IRN Log" getLogApi={getLogApi}>
          <TableContainer
            component={Paper}
            sx={{
              mb: 2,
              mt: 2,
              maxHeight: '51vh',
              overflow: 'auto',
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>

                  <TableCell style={{ fontFamily: "'Dosis'" }}>CREATED AT</TableCell>
                  <TableCell style={{ fontFamily: "'Dosis'" }}>INVOICE COUNT</TableCell>
                  <TableCell tyle={{ fontFamily: "'Dosis'" }}>ACTION</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : logData.length > 0 ? (
                  logData.map((row, index) => (
                    <TableRow key={`table-row-${index}`}>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>{row.created_time}</TableCell>
                      <TableCell style={{ fontFamily: "'Dosis'" }}>{row.invoice_count}</TableCell>
                      <TableCell>
                        <VisibilityIcon
                          color="primary"
                          onClick={() => getTableLogVisibility(row)}
                          style={{ cursor: 'pointer', marginLeft: '8px' }}
                        />
                      </TableCell>

                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </BoxWrapper>
      </div>


      <Dialog open={openPopup} onClose={handleClosePopup}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 24,
            px: 2,
            py: 1,
            marginLeft: 8,
            bgcolor: 'background.default',
            // minHeight: '70%',
          }
        }}>
        {/* <DialogTitle>GSTR-1 Filing Log Report Previous Month</DialogTitle> */}
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 1,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <BusinessIcon color="primary" />
            <Typography variant="h6" fontWeight="bold">
              E-Invoice Summary Error Report
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <BoxWrapper
            boxTitle="Einvoice-Summary Error Report"

          >
            <div className="responsive-table">
              <table className="custome-table">
                <thead>
                  <tr>
                    <th>Document Number</th>
                    <th>Error</th>

                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(errorLog) && errorLog.length > 0 ? (
                    errorLog.map((value) => (
                      <tr>
                        <td>{value.document_number}</td>
                        <td>{value.errors}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td style={{ color: 'red', textAlign: 'center' }} colSpan={3}>
                        No Data Found!!
                      </td>
                    </tr>
                  )}
                </tbody>
                {/* <tbody>
                        {logData?.map((value) => (
                          <tr>
                            <td>{value.record_run_date}</td>
                            <td>{value.report_month}</td>
                            <td>{value.status}</td>
                            <td></td>
                          </tr>
                        ))}
                        {logData?.length <= 0 && (
                          <tr>
                            <td style={{ color: "red", textAlign: "center" }} colSpan={6}>
                              No Data Found!!
                            </td>
                          </tr>
                        )}
                      </tbody> */}
              </table>
            </div>
          </BoxWrapper>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialog}
        onClose={handleCancelClose}
        sx={{ "& .MuiDialog-paper": { width: '50%' } }}
      >
        <DialogTitle>Cancel E-Invoice</DialogTitle>
        <DialogContent>
          <p>{dialogMessage}</p>
          <TextField
            multiline
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClear} color="secondary">
            Clear
          </Button>
          <Button onClick={handleCancelConfirm} color="primary">
            Submit
          </Button>
          <Button onClick={handleCancelClose} color="default">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        sx={{ mt: 4 }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={30000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          variant="filled"
          sx={{
            width: '100%',
            whiteSpace: 'pre-line',
            maxWidth: '500px'
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default Summary;